import Dexie from "dexie";
import type { DietTrackerDatabase } from "./database";

/** Joins an existing application transaction or starts a revision-tracked one. */
export function mutateDatabase<T>(database: DietTrackerDatabase, work: () => Promise<T>): Promise<T> {
  return Dexie.currentTransaction ? work() : database.runUserDataTransaction(work);
}

